<button type="button" [hidden]="isDisabled" id="{{containerId}}" class="preview-selection__element-container cfa-plain-button" (click)="elementClicked.emit()">
    <div class="preview-selection__text-container text-container" data-testid="preview-selection-text">
        {{text}}
    </div>
</button>
